export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceContentsId: 2,
      serviceContentsUuid: "servicecontents002",
      serviceContentsSettings: {
        // 基本設定
        contentsBasicSetting: {
          serviceTypeCd: 1,
          contentsName: "xxxxx",
          deviceTypeUuid: "device001",
          splashImageFile: {
            fileName: "splash.gif",
            contentType: "image/gif",
            fileUri: "/images/img01.gif",
            fileSize: 1024,
            thumbnailUri: "/images/img01.gif"
          },
          bgMusicFile: {
            fileName: "music.mp3",
            contentType: "audio/mpeg",
            fileUri: "/images/img01.mp3",
            fileSize: 1024,
            thumbnailUri: "/images/img01.mp3"
          },
          bgImage: {
            sourceType: 0,
            selectedFile: {
              fileName: "music.mp3",
              contentType: "audio/mpeg",
              fileUri: "/images/img01.mp3",
              fileSize: 1024,
              thumbnailUri: "/images/img01.mp3"
            },
          },
          bgPanelFlg: 1,
          bgPanelColor: "#000",
          bgPanelTransparency: 100,
          UseStartImage1: {
            fileName: "bg.gif",
            contentType: "image/gif",
            fileUri: "/images/img01.gif",
            fileSize: 1024,
            thumbnailUri: "/images/img01.gif"
          },
          UseStartImage2: {
            fileName: "bg.gif",
            contentType: "image/gif",
            fileUri: "/images/img01.gif",
            fileSize: 1024,
            thumbnailUri: "/images/img01.gif"
          },
          UseStartImage3: {
            fileName: "bg.gif",
            contentType: "image/gif",
            fileUri: "/images/img01.gif",
            fileSize: 1024,
            thumbnailUri: "/images/img01.gif"
          },
          screenOrientation: 0,
          screenBottomMargin: 0
        },
        // ヘッダー設定
        contentsHeader: {
          logoFile: {
            fileName: "bg.gif",
            contentType: "image/gif",
            fileUri: "/images/img01.gif",
            fileSize: 1024,
            thumbnailUri: "/images/img01.gif"
          },
          btnSettings: [
            {
              isDefaultFocusedFlg: 1,
              btnName: "xxxxxx",
              iconFile: {
                fileName: "bg.gif",
                contentType: "image/gif",
                fileUri: "/images/img01.gif",
                fileSize: 1024,
                thumbnailUri: "/images/img01.gif"
              },
              labelText: "xxxxxx",
              btnActionType: 1,
              btnActionParameter: {
                // screenCode: "xxxxx",
                webUrl: "xxxxx",
                localFile: {
                  fileName: "bg.gif",
                  contentType: "image/gif",
                  fileUri: "/images/img01.gif",
                  fileSize: 1024,
                  thumbnailUri: "/images/img01.gif"
                },
                dropBoxFile: {
                  serviceDropboxUuid: "xxxxxxx",
                  fileType: 3,
                },
                launchSpApp: "xxxxx"
              },
              badgeUseFlg: 1,
              badgeColor: "#f00",
              badgeText: "xxxxxx",
              badgeDisplayCondition: 0,
              badgeDisplayParameter: {
                deliveryTypes: ["family_info"],
              }
            },
            {
              isDefaultFocusedFlg: 1,
              btnName: "xxxxxx",
              iconFile: {
                fileName: "bg.gif",
                contentType: "image/gif",
                fileUri: "/images/img01.gif",
                fileSize: 1024,
                thumbnailUri: "/images/img01.gif"
              },
              labelText: "xxxxxx",
              btnActionType: 1,
              btnActionParameter: {
                screenCode: "contentsscreen022",
                webUrl: "xxxxx",
                localFile: {
                  fileName: "bg.gif",
                  contentType: "image/gif",
                  fileUri: "/images/img01.gif",
                  fileSize: 1024,
                  thumbnailUri: "/images/img01.gif"
                },
                dropBoxFile: {
                  serviceDropboxUuid: "xxxxxxx",
                  fileType: 3,
                },
                launchSpApp: "xxxxx"
              },
              badgeUseFlg: 1,
              badgeColor: "#f00",
              badgeText: "xxxxxx",
              badgeDisplayCondition: 1,
              badgeDisplayParameter: {
                serviceRssUUIDs: ["servicerss001"]
              }
            }
          ]
        },
        // 天気エリアコード設定
        contentsWeatherAreaCode: "17",
        // ビューワーモード設定
        contentsViewerMode: {
          viewerModeUseFlg: 1,
          deliveryTypes: ["signage", "family_info"],
          noticeTypes: ["noticeType003"],
          viewerTopImageFile: {
            fileName: "bg.gif",
            contentType: "image/gif",
            fileUri: "/images/img01.gif",
            fileSize: 1024,
            thumbnailUri: "/images/img01.gif"
          },
          weatherContentsShowFlg: 1,
          viewerTopDisplayInterval: 10,
          contentsDisplayInterval: 30
        },
        // スクリーンセーバー設定
        contentsScreenSaver: {
          screenSaverUseFlg: 1,
          startDelayTime: 5,
          dataSource: 1,
          dropBoxFile: {
            serviceDropboxUuid: "servicedropbox002",
            fileType: 2,
          }
        },
        // ライブカメラ設定
        contentsLiveCamera: {
          liveCameraUseFlg: 1,
          liveCameraSettings: [
            {
              caption: "街頭001",
              accessUrl: "http://xxx.xxx.xxx"
            }
          ]
        },
        // デザイン設定
        contentsDesign: {
          designIconMode: 0,
          defaultFontColor: "#000",
          focusFontColor: "#555",
          disableFontColor: "#ccc",
          defaultBtnStyle: {
            backgroundColor: "#333",
            transparency: 0,
            frameLineColor: "#000",
            frameLineWidth: 1
          },
          focusBtnStyle: {
            backgroundColor: "#333",
            transparency: 0,
            frameLineColor: "#000",
            frameLineWidth: 1,
            btnZoom: 50
          },
          disableBtnStyle: {
            backgroundColor: "#333",
            transparency: 0,
            frameLineColor: "#000",
            frameLineWidth: 1
          },
          slideImageAnimationAreaMargin: 10,
          defaultSlideImageAnimationArea: {
            framelineColor: "#000",
            frameLineWidth: 1
          },
          focusSlideImageAnimationArea: {
            framelineColor: "#000",
            frameLineWidth: 1
          },
          disableSlideImageAnimationArea: {
            framelineColor: "#000",
            frameLineWidth: 1
          },
          panelBackgroundColor: "#000",
          panelBackgroundTransparency: 10,
          btnRoundCornerUseFlg: 1,
          btnRectRoundCornerStyle: {
            roundCornerLeftTop: 3,
            roundCornerRightTop: 3,
            roundCornerLeftBottom: 3,
            roundCornerRightBottom: 3
          },
          badgeRoundCornerUseFlg: 0,
          badgeRectRoundCornerStyle: {
            roundCornerLeftTop: 3,
            roundCornerRightTop: 3,
            roundCornerLeftBottom: 3,
            roundCornerRightBottom: 3
          },
          thumbUpBtnlabel: "いいね"
        },
        // お知らせ受信時音声設定
        contentsNoticeSound: {
          noticeSoundJingleUseFlg: 1,
          noticeSoundjingleFile: {
            fileName: "bg.gif",
            contentType: "image/gif",
            fileUri: "/images/img01.gif",
            fileSize: 1024,
            thumbnailUri: "/images/img01.gif"
          },
          noticeSoundvoiceMessageUseFlg: 1,
          noticeSoundvoiceMessageFile: {
            fileName: "bg.gif",
            contentType: "image/gif",
            fileUri: "/images/img01.gif",
            fileSize: 1024,
            thumbnailUri: "/images/img01.gif"
          }
        },
        // キーアサイン設定
        contentsKeyAssignments: [
          {
            keyCode: 8,
            actionType: 3,
            parameter: "contentsscreen001"
          },
          {
            keyCode: 9,
            actionType: 2,
            parameter: "https://xxxxxx.xxxxxx"
          },
          {
            keyCode: 10,
            actionType: 1,
            parameter: "app://xxxxx.xxxxxx"
          }
        ],
      }
    }
  }
}